/*
 * This file is part of record-editor.
 * Copyright (C) 2017 CERN.
 *
 * record-editor is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License as
 * published by the Free Software Foundation; either version 2 of the
 * License, or (at your option) any later version.
 *
 * record-editor is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with record-editor; if not, write to the Free Software Foundation, Inc.,
 * 59 Temple Place, Suite 330, Boston, MA 02111-1307, USA.
 * In applying this license, CERN does not
 * waive the privileges and immunities granted to it by virtue of its status
 * as an Intergovernmental Organization or submit itself to any jurisdiction.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { JsonEditorModule } from 'ng2-json-editor';
import { SHARED_COMPONENTS } from './components';
import { SHARED_PIPES } from './pipes';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PopoverModule,
    ModalModule,
    BsDropdownModule,
    AccordionModule,
    TooltipModule,
  ],
  declarations: [
    ...SHARED_PIPES,
    ...SHARED_COMPONENTS,
  ],
  exports: [
    ...SHARED_PIPES,
    ...SHARED_COMPONENTS,
    CommonModule,
    FormsModule,
    PopoverModule,
    ModalModule,
    BsDropdownModule,
    AccordionModule,
    TooltipModule,
    JsonEditorModule,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/app/shared/shared.module.ts